export class CertificationReq{
    certificationId: number;

    constructor(certificaitonId: number){
        certificaitonId = certificaitonId;
    }
}